
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ActionedLink from './actioned-link'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "actionedlink"
    }}>{`ActionedLink`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "actioned-link"
    }}>{`Actioned link`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For links that prompt an external action, but does not affect or change data.`}</p>
    <Playground __position={1} __code={'<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"add\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"download\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"edit\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"listen\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"reuse-this-content\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"remove\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"the-trust-project\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"watch\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"copy\" />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"check\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ActionedLink
    }} mdxType="Playground">
  <ActionedLink href='/' text='Actioned link' icon='add' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='download' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='edit' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='listen' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='reuse-this-content' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='remove' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='the-trust-project' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='watch' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='copy' mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='check' mdxType="ActionedLink" />
    </Playground>
    <p><strong parentName="p">{`With additional props`}</strong></p>
    <p>{`Allows any valid HTML or React props to be passed through.`}</p>
    <Playground __position={2} __code={'<ActionedLink\n  href=\"#\"\n  text=\"Actioned link\"\n  icon=\"edit\"\n  onClick={() => alert(\'clicked!\')}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ActionedLink
    }} mdxType="Playground">
  <ActionedLink href='#' text='Actioned link' icon='edit' onClick={() => alert('clicked!')} mdxType="ActionedLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "actioned-link-minor"
    }}>{`Actioned link (minor)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For links that prompt an external action, but does not affect or change data. Useful for revisiting completed tasks or steps in a journey.`}</p>
    <Playground __position={4} __code={'<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"add\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"download\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"edit\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"listen\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"reuse-this-content\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"remove\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"the-trust-project\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"watch\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"copy\" minor />\n<ActionedLink href=\"/\" text=\"Actioned link\" icon=\"check\" minor />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ActionedLink
    }} mdxType="Playground">
  <ActionedLink href='/' text='Actioned link' icon='add' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='download' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='edit' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='listen' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='reuse-this-content' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='remove' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='the-trust-project' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='watch' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='copy' minor mdxType="ActionedLink" />
  <ActionedLink href='/' text='Actioned link' icon='check' minor mdxType="ActionedLink" />
    </Playground>
    <hr />
git branch --set-upstream-to=origin/add-apple-google-podcast-icons add-apple-google-podcast-icons
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ActionedLink} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;